import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiService } from '@shared/@services/api/api.service';
import { ApiResult } from '@shared/@types/api/api-result.type';
import { environment } from 'environments/environment';
import { of } from 'rxjs';
import { Company } from '../types/companies.type';
import { CompanyFilter } from '../types/company-filter.type';

@Injectable()
export class CompaniesService {
  private _url = 'companies';
  private _apiService = inject(ApiService);
  private _httpClient = inject(HttpClient);

  constructor() {}

  getCompanies(
    searchTxt: string = '',
    take?: number,
    skip?: number,
    filters?: Partial<CompanyFilter>,
  ) {
    return this._apiService.get<
      ApiResult<{ companies: Company[]; totalCount: number }>
    >(this._url, {
      searchTxt,
      take,
      skip,
      ...filters,
    });
  }

  exportToExcel(filters: string = '') {
    return this._httpClient.get(
      environment.apiUrl + this._url + `/export-excel${filters}`,
    );
  }

  getCompany(cr: string) {
    if (!cr) return of(null);
    return this._apiService.get<ApiResult<Company>>(`${this._url}/${cr}`);
  }
}
